export const INSURANCE_PANEL_NAME = 'insuranceProvider'
